import { createContext } from 'react'

import { ModalContextType } from './models'

export const ModalContext = createContext<ModalContextType | undefined>(undefined)
